import React, { useState, useContext, useRef, Fragment } from "react";
import moment from "moment";
import {
  makeStyles,
  Grid,
  Button,
  Typography,
  FormControl,
  Select,
  InputLabel,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  CircularProgress,
  InputAdornment,
  IconButton,
  Popper,
  ClickAwayListener,
} from "@material-ui/core";
import { LangContext } from "../../Context/Langcontext";
import { APIContext } from "../../Context/APIContext";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import { IoMdCalendar, IoIosSearch } from "react-icons/io";
import { getUsageStat } from "../../API/Usage";
import { ServiceContext } from "../../Context/ServiceContext";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "99.5%",
    height: "100%",
  },
  btnstyle: {
    borderRadius: 8,
    padding: "0.2rem 1.5rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    "&:hover": {
      background: "#E16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  btndis: {
    borderRadius: 8,
    padding: "0.5rem 1.5rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#ebebeb",
    color: "#FFFFFF",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    // width: "20rem",
    "& .MuiInputBase-root": {
      fontWeight: 200,
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      padding: "13.5px 14px",
    },
  },
  select: {
    "& .MuiSelect-icon": {
      color: "#E16733",
      fontSize: "2.25rem",
      top: "calc(50% - 18px)",
    },
    "& .MuiSelect-root": {
      padding: "0.8rem ",
      textOverflow: "ellipsis",
    },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      paddingRight: 32,
    },
    borderRadius: 8,
    fontWeight: 200,
  },
  texthead: {
    fontSize: "1rem",
    color: "#595A5A",
    fontWeight: 700,
  },
  tablecell: {
    borderBottom: "unset",
    fontSize: "1rem",
    fontWeight: 200,
    color: "#595A5A",
  },
  grid: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-start",
  },
  fontdetail: {
    fontSize: "1rem",
    color: "#595A5A",
    marginBottom: "2rem",
    fontWeight: 200,
  },
  itemform: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "2rem",
  },
  label: {
    transform: "translate(16px, 14px) scale(1)",
    fontWeight: 200,
  },
  cardapi: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.1rem",
    minHeight: "calc(100vh - 17.9rem)",
    maxHeight: "100%",
  },
  loading: {
    width: "100%",
    height: "40vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  search: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
}));

const Apiusage = () => {
  const classes = useStyle();
  const anchorRef = useRef();
  const [open, setOpen] = useState(false);
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const apiContext = useContext(APIContext);
  const [state, setstate] = useState({
    api: "other",
    type: "all",
    date: "today",
  });
  const serviceContext = useContext(ServiceContext);
  const [loading, setLoading] = useState(false);
  const [status, setstatus] = useState("okay");
  const [data, setData] = useState([]);

  const [date, setDate] = useState({
    startDate: moment().format("L"),
    endDate: moment().format("L"),
  });

  function createData(layer, cost, limit, usage, size, type) {
    return { layer, cost, limit, usage, size, type };
  }

  const findInDataApi = (id) => {
    let dataapi = serviceContext.data.find((rs) => {
      return rs.category === "data" && rs._id === id;
    });
    return dataapi;
  };

  const findInMapApi = (id) => {
    let dataapi = serviceContext.data.find((rs) => {
      return rs.category === "map" && rs._id === id;
    });
    return dataapi;
  };

  const showType = (id) => {
    let api = serviceContext.data.find((rs) => {
      return rs._id === id;
    });
    return api.category;
  };

  const rename = (s_id) => {
    const name = serviceContext.data.find((rs) => {
      return rs._id === s_id;
    });
    if (name) {
      return name.name;
    } else {
      return null;
    }
  };

  const reData = (e) => {
    let output = [];
    e.forEach(function (item) {
      var existing = output.filter(function (v, i) {
        return v.id === item._id.service_id;
      });

      if (existing.length) {
        var existingIndex = output
          .map((rs) => {
            return rs.id;
          })
          .indexOf(item._id.service_id);

        output[existingIndex].request = Number(
          Number(
            output[existingIndex].request
              ? Number(output[existingIndex].request)
              : 0
          ) + Number(item.sum_request)
        );
        output[existingIndex].cost = Number(
          Number(
            output[existingIndex].cost ? Number(output[existingIndex].cost) : 0
          ) + Number(item.sum_net)
        );
        output[existingIndex].size = Number(
          Number(
            output[existingIndex].size ? Number(output[existingIndex].size) : 0
          ) + Number(item.sum_size)
        );
      } else {
        if (typeof rename(item._id.service_id) === "string") {
          let input = {};
          input.id = item._id.service_id;
          input.name = rename(item._id.service_id);
          input.request = Number(item.sum_request);
          input.cost = Number(item.sum_net);
          input.size = Number(item.sum_size);
          input.type = showType(item._id.service_id);
          output.push(input);
        }
      }
    });
    return output;
  };

  const rows =
    state.type === "all"
      ? reData(data).map((rs) => {
          return createData(
            rs.name,
            rs.cost,
            100,
            rs.request,
            rs.size,
            rs.type
          );
        })
      : state.type === "data"
      ? reData(
          data.filter((res) => {
            return findInDataApi(res._id.service_id);
          })
        ).map((rs) => {
          return createData(
            rs.name,
            rs.cost,
            100,
            rs.request,
            rs.size,
            rs.type
          );
        })
      : reData(
          data.filter((res) => {
            return findInMapApi(res._id.service_id);
          })
        ).map((rs) => {
          return createData(
            rs.name,
            rs.cost,
            100,
            rs.request,
            rs.size,
            rs.type
          );
        });

  const getAll = () => {
    let count = 0;
    for (var i = 0; i < rows.length; i++) {
      count = Number(Number(count) + Number(rows[i].cost));
    }

    return count.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const getrequestAll = () => {
    let count = 0;
    for (var i = 0; i < rows.length; i++) {
      count = Number(Number(count) + Number(rows[i].usage));
    }

    return count.toLocaleString();
  };

  const getsizeAll = () => {
    let count = 0;
    for (var i = 0; i < rows.length; i++) {
      count = Number(Number(count) + Number(rows[i].size));
    }

    return count.toLocaleString();
  };

  const applyFunc = (e) => {
    e.preventDefault();
    setLoading(true);

    setTimeout(() => {
      getDataUsage();
      setLoading(false);
    }, 2000);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const getDataUsage = async () => {
    const toDay = moment(moment().format("L")).format("X");
    const endDay = moment().endOf("day").format("X");

    const rangeDate =
      state.date === "today"
        ? `${toDay},${endDay}`
        : state.date === "lastweek" // - 7 day
        ? `${moment(moment(moment().subtract(1, "week")).format("L")).format(
            "X"
          )},${endDay}`
        : state.date === "last2week" // -
        ? `${moment(moment(moment().subtract(2, "weeks")).format("L")).format(
            "X"
          )},${endDay}`
        : state.date === "lastmonth"
        ? `${moment(moment(moment().subtract(1, "month")).format("L")).format(
            "X"
          )},${endDay}`
        : state.date === "last3month"
        ? `${moment(moment(moment().subtract(3, "months")).format("L")).format(
            "X"
          )},${endDay}`
        : state.date === "last6month"
        ? `${moment(moment(moment().subtract(6, "months")).format("L")).format(
            "X"
          )},${endDay}`
        : state.date === "lastyear"
        ? `${moment(moment(moment().subtract(1, "year")).format("L")).format(
            "X"
          )},${endDay}`
        : `${moment(moment(date.startDate)).format("X")},${moment(
            moment(date.endDate).add(1, "day")
          ).format("X")}`;
    const send =
      state.api === "other"
        ? `/aggregate?datetime_ref=${rangeDate}&group=service_id,user_id,datetime_ref,apikey_id&sort=_id.datetime_ref:asc`
        : `/aggregate?datetime_ref=${rangeDate}&apikey_id=${state.api}&group=service_id,user_id,datetime_ref,apikey_id&sort=_id.datetime_ref:asc`;
    const get = await getUsageStat(send);

    if (get.status.code === 200) {
      setData(get.data);
      if (get.data.length === 0) {
        setstatus("error");
      } else {
        setstatus("okay");
      }
    } else {
      setstatus("error");
    }
  };

  const setClear = (e) => {
    e.preventDefault();
    setData([]);
    setstatus("okay");
  };

  return (
    <div className={classes.root}>
      <Card className={classes.cardapi}>
        <div style={{ width: "100%", height: "100%" }}>
          <div style={{ margin: "2rem" }}>
            <Grid container spacing={0}>
              <Grid item xs={12} className={classes.grid}>
                <Typography className={classes.fontdetail}>
                  {lang.SubtitlesAPIusage}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.itemform}>
                  <Grid
                    container
                    justify="space-between"
                    spacing={2}
                    component="form"
                    onSubmit={data.length ? setClear : applyFunc}
                  >
                    <Grid
                      item
                      xl={3}
                      lg={2}
                      md={3}
                      sm={6}
                      xs={6}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel
                          id="demo-simple-select-outlined-label"
                          className={classes.label}
                        >
                          {lang.ApiKey}
                        </InputLabel>
                        <Select
                          labelId="demo-api-key"
                          id="demo-customized-api"
                          disabled={data.length !== 0 ? true : false}
                          required
                          label={lang.ApiKey}
                          className={classes.select}
                          native
                          value={state.api}
                          onChange={(e) => {
                            setstate({ ...state, api: e.target.value });
                          }}
                        >
                          {apiContext.data.map((rs) => {
                            return (
                              <option key={rs._id} value={rs._id}>
                                {`${rs.app_name}-${rs.api_key.substring(0, 4)}`}
                              </option>
                            );
                          })}
                          <option value={"other"}>ทั้งหมด</option>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      xl={2}
                      lg={2}
                      md={3}
                      sm={6}
                      xs={6}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel
                          id="demo-simple-select-outlined-label"
                          className={classes.label}
                        >
                          {lang.Type}
                        </InputLabel>
                        <Select
                          labelId="demo-api-key"
                          id="demo-customized-api"
                          disabled={data.length !== 0 ? true : false}
                          required
                          label={lang.Type}
                          className={classes.select}
                          native
                          value={state.type}
                          onChange={(e) => {
                            setstate({ ...state, type: e.target.value });
                          }}
                        >
                          <option value="all">{lang.AllType}</option>
                          <option value="data">Data API</option>
                          <option value="map">Map API</option>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      xl={3}
                      lg={3}
                      md={6}
                      sm={12}
                      xs={12}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around",
                        marginBottom: "0.5rem",
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: "1rem",
                          fontWeight: 200,
                          color: "#595A5A",
                        }}
                      >
                        {lang.For}
                      </Typography>
                      <FormControl
                        variant="outlined"
                        style={{ width: "15rem", marginLeft: 8 }}
                      >
                        <InputLabel
                          id="demo-simple-select-outlined-label"
                          className={classes.label}
                        >
                          {lang.Period}
                        </InputLabel>
                        <Select
                          labelId="demo-api-key"
                          id="demo-customized-api"
                          disabled={data.length !== 0 ? true : false}
                          required
                          label={lang.Period}
                          className={classes.select}
                          native
                          value={state.date}
                          onChange={(e) => {
                            setstate({ ...state, date: e.target.value });
                          }}
                        >
                          <option value="today">{lang.Today}</option>
                          <option value="lastweek">{lang.Lastweek}</option>
                          <option value="last2week">{lang.Last2week}</option>
                          <option value="lastmonth">{lang.Lastmonth}</option>
                          <option value="last3month">{lang.Last3month}</option>
                          <option value="last6month">{lang.Last6month}</option>
                          <option value="lastyear">{lang.Lastyear}</option>
                          <option value="customperiod">
                            {lang.CustomPeriod}
                          </option>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      xl={3}
                      lg={3}
                      md={6}
                      sm={8}
                      xs={8}
                      style={{
                        marginBottom: "0.5rem",
                      }}
                    >
                      <TextField
                        variant="outlined"
                        ref={anchorRef}
                        id="date"
                        disabled={state.date === "customperiod" ? false : true}
                        label={
                          state.date === "customperiod" ? lang.SelectPeriod : ""
                        }
                        value={
                          state.date === "customperiod"
                            ? `${moment(date.startDate).format(
                                "DD/MM/YYYY"
                              )} - ${moment(date.endDate).format("DD/MM/YYYY")}`
                            : lang.SelectPeriod
                        }
                        className={classes.textField}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                disabled={
                                  state.date === "customperiod" ? false : true
                                }
                                style={{ padding: "unset" }}
                                onClick={() => {
                                  setOpen(true);
                                }}
                              >
                                <IoMdCalendar />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        InputLabelProps={{
                          shrink: true,
                          className: classes.label,
                        }}
                        fullWidth
                      />
                      <Popper
                        open={open}
                        anchorEl={anchorRef.current}
                        role={undefined}
                        transition
                        disablePortal
                        placement="bottom"
                      >
                        <ClickAwayListener onClickAway={handleClose}>
                          <Card elevation={3}>
                            <DateRange
                              editableDateInputs={true}
                              onChange={(item) => {
                                setDate({
                                  startDate: moment(item.selection.startDate),
                                  endDate: moment(item.selection.endDate),
                                });
                              }}
                              moveRangeOnFirstSelection={false}
                              ranges={[
                                {
                                  startDate: new Date(date.startDate),
                                  endDate: new Date(date.endDate),
                                  key: "selection",
                                },
                              ]}
                            />
                          </Card>
                        </ClickAwayListener>
                      </Popper>
                    </Grid>
                    <Grid
                      item
                      xl={1}
                      lg={2}
                      md={6}
                      sm={4}
                      xs={4}
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "0.5rem",
                      }}
                    >
                      <Button
                        type="submit"
                        className={loading ? classes.btndis : classes.btnstyle}
                        disabled={loading}
                      >
                        {data.length ? lang.Clear : lang.Apply}
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : rows.length === 0 ? (
                  status === "okay" ? (
                    <div className={classes.loading}>
                      <div className={classes.search}>
                        <IoIosSearch size={72} color="#7c7c7c" />
                        <Typography
                          align="center"
                          style={{
                            fontWeight: 400,
                            fontSize: "1rem",
                            color: "#595A5A",
                          }}
                        >
                          {data.length !== 0
                            ? "ไม่พบข้อมูล"
                            : `ค้นหา${lang.APIUsage}`}
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    <div className={classes.loading}>
                      <div className={classes.search}>
                        <IoIosSearch size={72} color="#7c7c7c" />
                        <Typography
                          align="center"
                          style={{
                            fontWeight: 400,
                            fontSize: "1rem",
                            color: "#595A5A",
                          }}
                        >
                          ไม่พบข้อมูล
                        </Typography>
                      </div>
                    </div>
                  )
                ) : (
                  <TableContainer>
                    <Table
                      className={classes.table}
                      aria-label="spanning table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell className={classes.texthead}>
                            {lang.Layer}
                          </TableCell>
                          <TableCell className={classes.texthead} align="right">
                            {`${lang.Request} (${lang.Times})`}
                          </TableCell>
                          <TableCell className={classes.texthead} align="right">
                            {`${lang.Size} (${lang.KB})`}
                          </TableCell>
                          <TableCell
                            className={classes.texthead}
                            style={{
                              width: "15%",
                            }}
                            align="right"
                          >
                            {`${lang.Cost} (${lang.THB})`}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows
                          .sort((a, b) => {
                            return a.type > b.type ? 1 : -1;
                          })
                          .map((row, index) => (
                            <Fragment key={`${row.layer}_${index}`}>
                              {state.type === "all" ? (
                                rows[index - 1] &&
                                rows[index - 1].type === row.type ? null : (
                                  <div style={{ marginTop: "0.5rem" }}>
                                    <Typography
                                      style={{
                                        color: "#595A5A",
                                        marginLeft: "1rem",
                                      }}
                                    >
                                      {`${row.type
                                        .charAt(0)
                                        .toUpperCase()}${row.type.slice(
                                        1
                                      )} API`}
                                    </Typography>
                                  </div>
                                )
                              ) : null}
                              <TableRow>
                                <TableCell className={classes.tablecell}>
                                  {row.layer}
                                  <div
                                    style={{
                                      width: "100%",
                                      backgroundColor: "#e3e2e4",
                                      height: "0.75rem",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: `${
                                          Number(row.usage / getrequestAll()) *
                                          100
                                        }%`,
                                        backgroundColor: "#E16733",
                                        height: "0.75rem",
                                      }}
                                    />
                                  </div>
                                </TableCell>
                                <TableCell
                                  align="right"
                                  className={classes.tablecell}
                                >
                                  {`${row.usage.toLocaleString()}`}
                                </TableCell>
                                <TableCell
                                  align="right"
                                  className={classes.tablecell}
                                >
                                  {`${row.size.toLocaleString(undefined, {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  })}`}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className={classes.tablecell}
                                  style={{
                                    borderLeft:
                                      "1px solid rgba(224, 224, 224, 1)",
                                  }}
                                ></TableCell>
                              </TableRow>
                            </Fragment>
                          ))}

                        <TableRow
                          style={{
                            backgroundColor: "#fbebe4",
                            borderBottom: "unset",
                          }}
                        >
                          <TableCell
                            colSpan={1}
                            className={classes.texthead}
                            style={{
                              borderBottom: "unset",
                              fontWeight: "bold",
                            }}
                          >
                            {lang.Total}
                          </TableCell>
                          <TableCell
                            align="right"
                            className={classes.texthead}
                            style={{
                              borderBottom: "unset",
                              fontWeight: "bold",
                            }}
                          >
                            {getrequestAll()}
                          </TableCell>
                          <TableCell
                            align="right"
                            className={classes.texthead}
                            style={{
                              borderBottom: "unset",
                              fontWeight: "bold",
                            }}
                          >
                            {getsizeAll()}
                          </TableCell>
                          <TableCell
                            align="center"
                            className={classes.texthead}
                            style={{
                              borderBottom: "unset",
                              borderLeft: "1px solid rgba(224, 224, 224, 1)",
                            }}
                          >
                            {state.type === "all" ? (
                              <Typography
                                className={classes.tablecell}
                                align="right"
                                style={{ fontWeight: "bold" }}
                              >
                                {getAll()}
                              </Typography>
                            ) : (
                              <Typography
                                className={classes.tablecell}
                                style={{ fontWeight: "bold" }}
                                align="right"
                              >
                                {getAll()}
                              </Typography>
                            )}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Grid>
            </Grid>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Apiusage;
